module.exports = __webpack_public_path__ + "img/45.559574da.jpg";